import { Container, Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { Button } from '../../UI/Button'

interface AutoPlayActionButtonProps {
  x: number
  y: number
  text: string
  onClick: () => void
  enabled: boolean
  color?: { enabled: string, normal: string }
}

export const AutoConfirmButton = (props: AutoPlayActionButtonProps) => {
  const width = 600
  const height = 84

  const color = { enabled: '#F0E1D4', normal: '#615D59' }
  return (
    <Container position={[props.x, props.y]}>
      <Button
        name={props.text}
        enabled={props.enabled}
        defaultView="auto_confirm_btn_normal"
        hoverView="auto_confirm_btn_hover"
        pressedView="auton_confirm_btn_pressed"
        disabledView="auton_confirm_btn_disable"
        x={0}
        y={0}
        width={width}
        height={height}
        onPress={props.onClick}
      />
      <Text
        text={props.text.toString()}
        x={width / 2}
        y={height / 2}
        anchor={0.5}
        style={
          new TextStyle({
            fontSize: 40,
            fontFamily: 'Arial',
            fontWeight: 'bold',
            fill: props.enabled ? color.enabled : color.normal,
            align: 'center',
          })
        }
      />
    </Container>
  )
}
